import { ReactNode } from 'react';

import {Spinner} from './Spinner';
import styles from './Loading.module.css';

interface LoadingProps {
  children?: ReactNode;
}

export const Loading = ({ children }: LoadingProps) => {
    return (
        <div className={styles.loading}>
            <Spinner></Spinner>
            {children && <p className={styles.loading__text}>{children}</p>}
        </div>
    )
}